export const SERP_TAB_IDS = ['places', 'sistaminuten'] as const;

export type SerpTabId = (typeof SERP_TAB_IDS)[number];

export type SerpTabItem = {
  id: SerpTabId;
  count?: number;
  countLoading?: boolean;
  href: string;
};
